module.exports = __webpack_public_path__ + "img/en2024.43a3ad9c.png";